module.exports = __webpack_public_path__ + "static/media/ConstellationLines.06ad0aac.dat";